import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ChevronRight } from 'lucide-react';
import { SERVICES } from '../data';
import { useSiteInfo } from '../context/SiteContext';

export default function Footer() {
  const { siteInfo } = useSiteInfo();
  
  return (
    <footer className="bg-primary-dark text-gray-300 border-t-2 border-accent pt-12 pb-[calc(96px+env(safe-area-inset-bottom,0px))] md:pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4 uppercase border-b-2 border-accent pb-2 inline-block">
              Thông tin liên hệ
            </h3>
            <div className="space-y-3">
              <p className="font-bold text-white uppercase">{siteInfo.name}</p>
              <p className="flex items-start">
                <MapPin size={18} className="mr-2 mt-1 flex-shrink-0 text-accent" />
                <a href="https://maps.app.goo.gl/r4SmC4ZYtN9uR3kr5" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">
                  {siteInfo.address}
                </a>
              </p>
              <p className="flex items-center"><Phone size={18} className="mr-2 text-accent" /> <span>Điện thoại: {siteInfo.phone}</span></p>
              <p className="flex items-center"><Mail size={18} className="mr-2 text-accent" /> <span>Email: {siteInfo.email}</span></p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4 uppercase border-b-2 border-accent pb-2 inline-block">
              Dịch vụ chính
            </h3>
            <ul className="space-y-2">
              {SERVICES.slice(0, 8).map(service => (
                <li key={service.id}>
                  <Link to={`/${service.slug}`} className="hover:text-accent transition-colors flex items-center">
                    <ChevronRight size={16} className="mr-1 flex-shrink-0" /> <span className="truncate">{service.title}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Nav Links */}
          <div>
            <h3 className="text-xl font-bold text-white mb-4 uppercase border-b-2 border-accent pb-2 inline-block">
              Liên kết
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/gioi-thieu" className="hover:text-accent transition-colors flex items-center">
                  <ChevronRight size={16} className="mr-1 flex-shrink-0" /> <span className="truncate">Giới thiệu</span>
                </Link>
              </li>
              <li>
                <Link to="/bang-gia" className="hover:text-accent transition-colors flex items-center">
                  <ChevronRight size={16} className="mr-1 flex-shrink-0" /> <span className="truncate">Bảng giá</span>
                </Link>
              </li>
              <li>
                <Link to="/tin-tuc" className="hover:text-accent transition-colors flex items-center">
                  <ChevronRight size={16} className="mr-1 flex-shrink-0" /> <span className="truncate">Tin tức</span>
                </Link>
              </li>
              <li>
                <Link to="/tuyen-dung" className="hover:text-accent transition-colors flex items-center">
                  <ChevronRight size={16} className="mr-1 flex-shrink-0" /> <span className="truncate">Tuyển dụng</span>
                </Link>
              </li>
              <li>
                <Link to="/dang-ky" className="hover:text-accent transition-colors flex items-center">
                  <ChevronRight size={16} className="mr-1 flex-shrink-0" /> <span className="truncate">Đăng ký dịch vụ</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 pr-14 md:pr-0 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
